import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { GlobalThemeContext, LocalThemeContext } from '../ThemeContext';
import useTheme from '../useTheme';
import { STORAGE_KEY } from '../constants';
import { getInitialValue } from './helpers';

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      _ref$isChangeDisabled = _ref.isChangeDisabled,
      isChangeDisabled = _ref$isChangeDisabled === void 0 ? false : _ref$isChangeDisabled,
      children = _ref.children,
      className = _ref.className;

  var _useTheme = useTheme(),
      globalTheme = _useTheme.globalTheme,
      localTheme = _useTheme.localTheme;

  var _useState = useState(getInitialValue(theme, globalTheme, localTheme)),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    setValue(getInitialValue(theme, globalTheme, localTheme));
  }, [theme, globalTheme, localTheme]);

  var onSetGlobalTheme = function onSetGlobalTheme(newValue) {
    setValue(newValue);
    localStorage.setItem(STORAGE_KEY, newValue);
  };

  var ui = /*#__PURE__*/React.createElement("div", {
    className: classnames("theme-".concat(value), className)
  }, children);

  if (globalTheme) {
    return /*#__PURE__*/React.createElement(LocalThemeContext.Provider, {
      value: {
        localTheme: value
      }
    }, ui);
  }

  return /*#__PURE__*/React.createElement(GlobalThemeContext.Provider, {
    value: {
      globalTheme: value,
      setGlobalTheme: onSetGlobalTheme,
      isChangeDisabled: isChangeDisabled
    }
  }, ui);
};

export default ThemeProvider;